console.log("⭐ VARIANT IMAGE FIX - WORKING VERSION + AUTO ADVANCE");

(function() {
    
    var colorToMediaId = {};
    var variantsToKeep = {};
    var hasNavigatedOnce = false; // Track if we've done initial navigation
    
    // ========================================
    // 1. BLOCK SCROLLINTOVIEW
    // ========================================
    var originalScrollIntoView = Element.prototype.scrollIntoView;
    Element.prototype.scrollIntoView = function() {
        if (this.classList && (this.classList.contains('t4s-product__media-item') || this.closest('.t4s-product__media-item'))) {
            console.log("🚫 Blocked scrollIntoView");
            return false;
        }
        return originalScrollIntoView.apply(this, arguments);
    };
    console.log("✅ scrollIntoView blocked");
    
    // ========================================
    // 1.5 ADD LOADING OVERLAY CSS
    // ========================================
    var overlayStyle = document.createElement('style');
    overlayStyle.textContent = `
        .variant-loading-overlay {
            position: fixed;
            top: 0;
            left: 0;
            width: 100%;
            height: 100%;
            background: white;
            z-index: 9999;
            opacity: 0;
            pointer-events: none;
            transition: opacity 0.15s ease;
        }
        .variant-loading-overlay.active {
            opacity: 1;
            pointer-events: auto;
        }
    `;
    document.head.appendChild(overlayStyle);
    
    // Create overlay element
    var overlay = document.createElement('div');
    overlay.className = 'variant-loading-overlay';
    document.body.appendChild(overlay);
    console.log("✅ Loading overlay created");
    
    // ========================================
    // 2. CACHE & REMOVE DUPLICATES
    // ========================================
    function cacheAndRemoveVariants() {
        if (typeof jQuery_T4NT === 'undefined') {
            setTimeout(cacheAndRemoveVariants, 100);
            return;
        }
        
        var $ = jQuery_T4NT;
        
        console.log("\n📦 Caching and removing duplicate variants...");
        
        var allVariants = $('.t4s-product__media-item--variant');
        console.log("  Found", allVariants.length, "variants");
        
        var removedCount = 0;
        
        allVariants.each(function(idx) {
            var $variant = $(this);
            var mediaId = $variant.attr('data-media-id');
            var $img = $variant.find('img').first();
            var dataMaster = $img.attr('data-master') || '';
            var dataSrc = $img.attr('data-src') || '';
            
            var colorMatch = dataMaster.match(/[/_]([A-Z][a-z]+(?:[A-Z][a-z]+)*)\./);
            var colorName = colorMatch ? colorMatch[1] : null;
            
            var variantData = {
                mediaId: mediaId,
                colorName: colorName,
                dataMaster: dataMaster,
                dataSrc: dataSrc,
                src: $img.attr('src'),
                srcset: $img.attr('srcset'),
                alt: $img.attr('alt')
            };
            
            if (idx === 0) {
                console.log("  ✅ Keeping first variant:", colorName);
                // ALSO cache the first variant so we can swap back to it
                if (colorName) {
                    variantsToKeep[colorName] = variantData;
                    colorToMediaId[colorName] = mediaId;
                }
            } else {
                if (colorName) {
                    variantsToKeep[colorName] = variantData;
                    colorToMediaId[colorName] = mediaId;
                }
                $variant.remove();
                removedCount++;
            }
        });
        
        console.log("  🗑️ Removed", removedCount, "duplicate variants");
        console.log("  💾 Cached", Object.keys(colorToMediaId).length, "colors");
        console.log("✅ Cleanup complete\n");
        
        // Navigate on page load
        setTimeout(function() {
            console.log("📍 Initial page load navigation...");
            navigateToFirst();
        }, 500);
    }
    
    // ========================================
    // 3. NAVIGATE TO FIRST POSITION
    // ========================================
    function navigateToFirst() {
        if (typeof jQuery_T4NT === 'undefined') return;
        
        var $ = jQuery_T4NT;
        
        console.log("  🔄 Forcing gallery to position 0...");
        
        var $allItems = $('.t4s-product__media-item');
        var $first = $allItems.first();
        var $container = $first.parent();
        
        // Remove is-selected from all items
        $allItems.removeClass('is-selected is-active active');
        
        // Add is-selected ONLY to first item
        $first.addClass('is-selected');
        
        console.log("  ✅ Set first item as selected");
        
        // Force container scroll to 0
        if ($container[0]) {
            $container[0].scrollLeft = 0;
            console.log("  ✅ Reset scroll to 0");
        }
        
        // Trigger slider events to sync internal state
        try {
            $container.trigger('select.flickity', [0]);
            $container.trigger('change.flickity', [0]);
            console.log("  ✅ Triggered slider sync events");
        } catch(e) {
            console.log("  ⚠️ Could not trigger events:", e.message);
        }
        
        // Also try to update any data attributes the slider might use
        $container.attr('data-flickity-index', '0');
        $first.attr('data-index', '0');
        
        // Verify
        setTimeout(function() {
            var $active = $allItems.filter('.is-selected').first();
            var activeIndex = $allItems.index($active);
            
            console.log("  Verification: Active index =", activeIndex);
            
            if (activeIndex === 0) {
                console.log("  ✅ Gallery at position 0!");
                hasNavigatedOnce = true; // Mark that we've navigated once
            } else {
                console.log("  ⚠️ Still at position", activeIndex);
            }
        }, 100);
    }
    
    // ========================================
    // 4. SWAP IMAGE
    // ========================================
    function swapImage(targetMediaId) {
        if (typeof jQuery_T4NT === 'undefined') return;
        
        var $ = jQuery_T4NT;
        
        // Show loading overlay immediately
        $('.variant-loading-overlay').addClass('active');
        console.log("  ⬜ Overlay shown");
        
        console.log("\n🔄 Swapping variant image...");
        console.log("  Target ID:", targetMediaId);
        
        var $first = $('.t4s-product__media-item').first();
        var currentMediaId = $first.attr('data-media-id');
        
        if (currentMediaId === targetMediaId) {
            console.log("  ✓ Already showing");
            $('.variant-loading-overlay').removeClass('active');
            console.log("  ⬜ Overlay hidden\n");
            return;
        }
        
        // Find in cache
        var variantData = null;
        for (var color in variantsToKeep) {
            if (variantsToKeep[color].mediaId === targetMediaId) {
                variantData = variantsToKeep[color];
                console.log("  ✅ Found:", color);
                break;
            }
        }
        
        if (!variantData) {
            console.log("  ❌ Not found in cache");
            return;
        }
        
        var $firstImg = $first.find('img').first();
        
        // Update
        $first.attr('data-media-id', targetMediaId);
        
        if (variantData.dataMaster) $firstImg.attr('data-master', variantData.dataMaster);
        if (variantData.dataSrc) $firstImg.attr('data-src', variantData.dataSrc);
        if (variantData.alt) $firstImg.attr('alt', variantData.alt);
        
        var realSrc = variantData.dataSrc || variantData.dataMaster;
        
        if (realSrc && !realSrc.includes('data:image/svg')) {
            $firstImg.attr('src', realSrc);
            $firstImg[0].src = realSrc;
            
            if (variantData.dataMaster) {
                var srcset = [400, 600, 800, 1000, 1200, 1400].map(function(w) {
                    return variantData.dataMaster + '&width=' + w + ' ' + w + 'w';
                }).join(', ');
                $firstImg.attr('srcset', srcset);
            }
        }
        
        console.log("  ✅ Swapped!");
        
        // Always navigate to show the swapped variant
        setTimeout(function() {
            navigateToFirst();
        }, 5); // Minimal delay - was 50ms
        
        // SIMPLE FIX: Click next button once to show variant
        setTimeout(function() {
            var $nextBtn = $('.flickityt4s-button.next, button.next').filter(':visible').first();
            if ($nextBtn.length) {
                console.log("  🔘 Auto-clicking next to show variant...");
                $nextBtn[0].click();
                console.log("  ✅ Next clicked!");
                
                // Hide overlay after navigation completes
                setTimeout(function() {
                    $('.variant-loading-overlay').removeClass('active');
                    console.log("  ⬜ Overlay hidden\n");
                }, 200); // Wait 200ms for navigation animation
            } else {
                // No button found, hide overlay anyway
                $('.variant-loading-overlay').removeClass('active');
                console.log("  ⬜ Overlay hidden (no button)\n");
            }
        }, 25); // Minimal delay after swap - was 100ms
    }
    
    // ========================================
    // 5. SETUP LISTENERS
    // ========================================
    function setupListeners() {
        if (typeof jQuery_T4NT === 'undefined') {
            setTimeout(setupListeners, 100);
            return;
        }
        
        var $ = jQuery_T4NT;
        
        console.log("🎧 Setting up listeners...");
        
        // Swatch clicks
        $(document).on('click', '[data-swatch-item]', function() {
            var swatchValue = $(this).attr('data-value') || $(this).text().trim();
            var color = swatchValue.replace(/\s+/g, '');
            
            console.log("\n🎯 Swatch clicked:", swatchValue);
            
            var mediaId = colorToMediaId[color];
            
            if (mediaId) {
                setTimeout(function() {
                    swapImage(mediaId);
                }, 10); // Reduced from 50ms to 10ms
            } else {
                console.log("  ❌ Color not found:", color);
            }
        });
        
        // Select dropdown
        $(document).on('change', 'select[name="id"]', function() {
            var text = $(this).find('option:selected').text().trim();
            var colorName = text.split(' - ')[0];
            var color = colorName.replace(/\s+/g, '');
            
            console.log("\n🎯 Select changed:", colorName);
            
            var mediaId = colorToMediaId[color];
            
            if (mediaId) {
                setTimeout(function() {
                    swapImage(mediaId);
                }, 10); // Reduced from 50ms to 10ms
            }
        });
        
        console.log("✅ Listeners ready\n");
    }
    
    // ========================================
    // 6. INITIALIZE
    // ========================================
    function init() {
        console.log("\n" + "=".repeat(80));
        console.log("🚀 VARIANT IMAGE FIX - INITIALIZING");
        console.log("=".repeat(80));
        
        cacheAndRemoveVariants();
        setupListeners();
    }
    
    if (document.readyState === 'loading') {
        document.addEventListener('DOMContentLoaded', init);
    } else {
        init();
    }
    
    if (typeof jQuery_T4NT !== 'undefined') {
        jQuery_T4NT(document).ready(init);
    }
    
})();